<template>
  <div id="Endereco" class="small">
    <span>
      Logradouro: {{endereco.logradouro}}, {{endereco.numero}} - {{endereco.bairro}} - {{ endereco.complemento}} - {{endereco.municipio}}({{endereco.uf}})
    </span>
    <div class="modal-footer">
      <slot name="footer">
        <button class="btn btn-cancel" type="cancel" @click="closeModal($event)">Fechar</button>
      </slot>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Endereco',
  props: ["endereco"],
  methods: {
    closeModal(){
      this.$emit('list-closeModalEndereco');
    }
  }
 
}
</script>
